/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { LogInPage } from '@/pages/LogIn/LogInPage';

export function LoginRoute() {
  return <LogInPage />;
}
